import UniversalWebView from '@/components/UniversalWebView'
import { getAuthToken } from '@/lib/api/authToken'
import { useSwitchTeam } from '@/lib/hooks/useSwitchTeam'
import { saveFileFromRemoteUrl, saveImageFromBase64 } from '@/lib/utils/fsSaver'
import { openPublishSheet } from '@/redux/slices/publishSheetSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { PlanCode } from '@/typings/domain'
import { handleClickToPay } from '@/modules/handleClickToPay'
import { router } from 'expo-router'
import { get } from 'lodash-es'
import { useCallback, useMemo } from 'react'

export default function FormReports({ formToken }: { formToken: string }) {
  const dispatch = useAppDispatch()
  const switchTeam = useSwitchTeam()
  const currentUser = useAppSelector(state => state.currentUser.user)

  const uri = useMemo(() => {
    const token = getAuthToken()
    return `${process.env.EXPO_PUBLIC_NEXT_BASE_URL}/m/forms/${formToken}/reports?m_t=${token}`
  }, [formToken])

  const handleMessage = useCallback(
    (data: { event: string; details: unknown }) => {
      if (data.event === 'EXPORT_CHART') {
        const dataURL = get(data.details, 'dataURL', '')
        const filename = get(data.details, 'label', 'export')

        if (dataURL) {
          return saveImageFromBase64(dataURL, filename)
        }
      }

      if (data.event === 'EXPORT_REPORTS') {
        const url = get(data.details, 'url', '')

        return saveFileFromRemoteUrl(url)
      }

      if (data.event === 'CLICK_TO_PAY') {
        const recommendedPlanCode = get(data.details, 'recommendedPlanCode') as PlanCode | undefined
        handleClickToPay({ recommendedPlanCode, currentUser: currentUser ?? undefined })
        return
      }

      if (data.event === 'PUBLISH_FORM') {
        const formToken = get(data.details, 'formToken') as string | undefined
        if (formToken) {
          dispatch(openPublishSheet({ formToken }))
        }
        return
      }

      if (data.event === 'FORM_NOT_FOUND') {
        router.replace('/forms')
        return
      }

      if (data.event === 'SWITCH_TEAM') {
        const userId = get(data.details, 'userId') as string | undefined
        if (userId) {
          switchTeam(userId)
        } else {
          router.push('/profile/switchUser')
        }
        return
      }

      // alert(`TODO: ${data.event}, ${JSON.stringify(data.details)}`)
    },
    [currentUser, dispatch, switchTeam]
  )

  return (
    <UniversalWebView
      source={{ uri }}
      className="flex-1 bg-background-muted"
      onMessage={handleMessage}
      onContentReady={() => { }}
    />
  )
}
